import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VListItem,[(_vm.getUser)?[_c(VListItemAvatar,[(_vm.getUser.avatarurl)?_c('img',{attrs:{"src":_vm.getUser.avatarurl}}):_c('img',{attrs:{"src":_vm.getDefaultAvatar}})]),_c(VListItemContent,[_c(VListItemTitle,{domProps:{"innerHTML":_vm._s(_vm.getUser.username)}}),_c(VListItemSubtitle,{domProps:{"innerHTML":_vm._s(_vm.getUser.name)}})],1)]:(_vm.loading)?_c('loading'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }